import React, { useContext } from 'react';
import Link from '@/presentation/link';
import Text from '@/presentation/text';
import { LoginRoute } from '@/common/routes';
import { ThemeContext } from 'styled-components';

const ForgotPasswordConfirmationFooter: React.FC = () => {
  const { colors } = useContext(ThemeContext);
  const basePath = (window as any).CSG_CONFIG.BASE_PATH;

  return (
    <>
      <Text id="idReturnTo" size="xs" color={colors.secondaryText} style={{ marginTop: '135px' }}>
        Return to &nbsp;
        <Link onClick={`/${basePath}/${LoginRoute}`} id="lnkLogIn" label="Log In" type="secondary" size="s" />
      </Text>
    </>
  );
};

export default ForgotPasswordConfirmationFooter;
